import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';

export default () => <Global styles={css`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    font-family: 'Noto Sans JP', sans-serif;
    line-height: 1.75;
    touch-action: manipulation;
  }

  body {
    margin: 0;
    background-color: #FDFBFA;
    -webkit-text-size-adjust: 100%;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: inherit;
  }

  ul,
  ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  input{
    -webkit-appearance: none;
  }
`}/>
